import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

import { from, Observable, of, take, tap } from 'rxjs';

import { TmtLoggerService } from 'tmt-logger';

/**
 * Provides methods to check for updates to the application.
 */
@Injectable()
export class UpdateService {
	/**
	 * Constructor
	 * @param swUpdate To get new version status.
	 * @param logger
	 */
	constructor(
		private swUpdate: SwUpdate,
		private logger: TmtLoggerService,
	) {}

	/**
	 * Checks for version update.
	 * @returns True if update ready to install, false otherwise.
	 */
	public updatesAvailable$(): Observable<boolean> {
		if (this.swUpdate.isEnabled) {
			return from(this.swUpdate.checkForUpdate()).pipe(
				tap(updateAvailable => {
					if (updateAvailable) {
						this.logger.logDebug('Found new application version ready for activation.');
					}
				}),
				take(1),
			);
		} else {
			return of(false);
		}
	}
}
